module.exports = __webpack_public_path__ + "img/covid_shipping.8bd59ab.png";